/*
 * Eraya price-test theme bridge — DogFriendlyCo (customized Dawn).
 *
 * The PriceTestEngine does NOT watch the DOM. This theme updates prices in two
 * dynamic ways that must be re-synced after the engine's initial scan:
 *
 *   1. PDP variant change: `variant-selects` (global.js) fetches the section and
 *      does `#price-{section}.innerHTML = source.innerHTML` with the ORIGINAL
 *      price, then publishes the Dawn pubsub event `variant-change`. The morphed
 *      `.price` node already carries data-product-id + data-variant-id (from
 *      snippets/price.liquid), so we just need to re-apply the test price — and
 *      do it SYNCHRONOUSLY so the base price never flashes.
 *   2. AJAX cards: product-recommendations, predictive search and quick-add
 *      inject new [data-product-id] cards after load.
 *   3. Searchanise (searchserverapi.com) search dropdown + results render their
 *      OWN card markup (`li.snize-product`) that no Liquid can touch. Those cards
 *      carry `data-original-product-id` (NOT `data-product-id`) and expose no
 *      variant, so the engine can't see them. We mirror the id onto
 *      `data-product-id` so it matches on product id alone, then rescan.
 *      Searchanise price nodes: `.snize-price` (selling), `.snize-discounted-price`
 *      (the "Old price" / compare — note the misleading class name).
 *
 * Marker string for deploy verification: priceMorph
 */
(function () {
  'use strict';

  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') {
        return E.sdk.getPriceTestManager();
      }
    } catch (_) {}
    return null;
  }

  var applying = false;
  var rescanTimer = null;
  function rescan() {
    if (applying) return;
    var mgr = getManager();
    if (!mgr || typeof mgr.updatePricesOnCurrentPage !== 'function') return;
    applying = true;
    try { mgr.updatePricesOnCurrentPage(); } catch (_) {}
    applying = false;
  }
  // Debounced rescan for chatty surfaces (cart drawer / page, where Discount
  // Ninja + HulkApps re-render prices repeatedly). PDP variant flash is handled
  // synchronously by the pubsub path below, so the observer can safely debounce.
  function scheduleRescan() { clearTimeout(rescanTimer); rescanTimer = setTimeout(rescan, 150); }
  function reapplyProduct(productId, variantId) {
    if (applying) return;
    var mgr = getManager();
    if (!mgr) return;
    applying = true;
    try {
      if (variantId && productId && typeof mgr.updatePricesForProduct === 'function') {
        mgr.updatePricesForProduct(String(productId), String(variantId));
      } else if (typeof mgr.updatePricesOnCurrentPage === 'function') {
        mgr.updatePricesOnCurrentPage();
      }
    } catch (_) {}
    applying = false;
  }

  // priceMorph — 1. VARIANT CHANGE (PDP). Dawn pubsub. Payload:
  //   { data: { sectionId, html, variant } }
  function onVariantChange(payload) {
    var d = payload && payload.data;
    if (!d) return;
    var sectionId = d.sectionId;
    var variantId = d.variant && String(d.variant.id);
    var productId = null;
    // Read the freshly-morphed price node — it already has both attributes.
    var container = sectionId && document.getElementById('price-' + sectionId);
    var priceEl = container && container.querySelector('[data-product-id]');
    if (priceEl) {
      productId = priceEl.getAttribute('data-product-id');
      // Keep the wrapper's variant-id in sync with the selected variant.
      if (variantId) {
        container.querySelectorAll('[data-variant-id]').forEach(function (el) {
          el.setAttribute('data-variant-id', variantId);
        });
      }
    }
    reapplyProduct(productId, variantId);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange); } catch (_) {}
  } else {
    // Fallback if the pubsub globals load after us.
    document.addEventListener('variant-change', function (e) { onVariantChange(e.detail); });
  }

  // priceMorph — Searchanise shim. Copy data-original-product-id -> data-product-id
  // on any snize card so the engine collects it. Attribute-only writes never
  // re-trigger the childList observer below. Returns true if it touched anything.
  function mirrorSnize(root) {
    if (!root || root.nodeType !== 1) return false;
    var touched = false;
    var cards = [];
    if (root.matches && root.matches('.snize-product[data-original-product-id]')) cards.push(root);
    if (typeof root.querySelectorAll === 'function') {
      var found = root.querySelectorAll('.snize-product[data-original-product-id]');
      for (var i = 0; i < found.length; i++) cards.push(found[i]);
    }
    for (var k = 0; k < cards.length; k++) {
      var c = cards[k];
      if (!c.hasAttribute('data-product-id')) {
        c.setAttribute('data-product-id', c.getAttribute('data-original-product-id'));
        touched = true;
      }
    }
    return touched;
  }

  // priceMorph — 2. Re-render / AJAX observer. childList only (never attributes,
  // to avoid self-triggering on the engine's own text rewrites). Covers cart
  // drawer / cart page re-renders, product-recommendations, predictive search
  // and quick-add. Debounced (see scheduleRescan) so DN/HulkApps cart churn
  // doesn't trigger a rescan storm.
  var SEL = '.price, [class*="price-item--"], [data-product-id], [data-original-product-id],' +
    ' .cart-item__final-price, .cart-item__old-price, .snize-product';
  function isRelevant(n) {
    if (n.nodeType !== 1) return false;
    if (n.matches && n.matches(SEL)) return true;
    return typeof n.querySelector === 'function' && n.querySelector(SEL) !== null;
  }
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (muts) {
      if (applying) return;
      var hit = false;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (isRelevant(added[j])) { mirrorSnize(added[j]); hit = true; }
        }
      }
      if (hit) scheduleRescan();
    });
    function start() {
      mirrorSnize(document.body); // cards already present at load (search results page)
      obs.observe(document.body, { childList: true, subtree: true });
    }
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }

  // priceMorph — 3. CART /cart/add INJECTION (so the shopper is CHARGED the test
  // price at checkout, not just shown it).
  //
  // The SDK's CartTrackingManager is meant to patch fetch/XHR on /cart/add and
  // attach _eraya_* line-item properties, which a cart-transform Function reads
  // at checkout. On this store that patch is bypassed — instant-pixel.js (and
  // possibly HulkApps / Discount Ninja) also wrap fetch/XHR, and depending on
  // load order the SDK's wrapper never sees the request. This bridge loads LAST
  // and re-wraps window.fetch + XMLHttpRequest so add-to-cart calls made by
  // global reference at call time hit our injector.
  //
  // We ONLY use the SDK's own property builder — never invent _eraya_* keys. If
  // the product isn't under test (builder returns null/empty), we inject nothing
  // and let the request proceed untouched.

  function isCartAdd(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  var warnedNoBuilder = false;
  function buildProps(variantId) {
    var mgr = getManager();
    if (!mgr || variantId == null) return null;
    // Defensive: only ever build props for a SCALAR variant id. The name-patch
    // multi-add sends `id` as an ARRAY; that case is split into per-line items[]
    // by injectBody before we get here, so each call still passes one scalar.
    if (typeof variantId === 'object') return null;
    var productId = null;
    try {
      if (typeof mgr.getProductIdFromVariantId === 'function') {
        productId = mgr.getProductIdFromVariantId(String(variantId));
      }
    } catch (_) {}
    var builder = null;
    if (typeof mgr.getSimpleCartProperties === 'function') builder = mgr.getSimpleCartProperties.bind(mgr);
    else if (window.Eraya && window.Eraya.sdk && typeof window.Eraya.sdk.getSimpleCartProperties === 'function') {
      builder = window.Eraya.sdk.getSimpleCartProperties.bind(window.Eraya.sdk);
    }
    if (!builder) {
      if (!warnedNoBuilder) { warnedNoBuilder = true; try { console.warn('[eraya-bridge] getSimpleCartProperties not found on SDK — cart injection disabled'); } catch (_) {} }
      return null;
    }
    try {
      var props = builder(productId != null ? String(productId) : null, String(variantId));
      return props && Object.keys(props).length ? props : null;
    } catch (_) { return null; }
  }

  function hasEraya(str) { return typeof str === 'string' && str.indexOf('_eraya_') !== -1; }

  // Returns a possibly-new body with _eraya_* properties merged in, or the
  // original body unchanged when there's nothing to add / product isn't in a test.
  function injectBody(body) {
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var idF = body.get('id');
        if (!idF) return body;
        var keys = []; body.forEach(function (_v, k) { keys.push(k); });
        if (keys.some(hasEraya)) return body;         // already injected upstream
        var pF = buildProps(idF); if (!pF) return body;
        Object.keys(pF).forEach(function (k) { body.append('properties[' + k + ']', String(pF[k])); });
        return body;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var idU = body.get('id');
        if (!idU || hasEraya(body.toString())) return body;
        var pU = buildProps(idU); if (!pU) return body;
        Object.keys(pU).forEach(function (k) { body.set('properties[' + k + ']', String(pU[k])); });
        return body;
      }
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{' || t.charAt(0) === '[') {
          if (hasEraya(body)) return body;
          var obj = JSON.parse(body);

          // Shape C — bare multi-add with an id ARRAY, e.g. the name-patch flow:
          //   { quantity, id: [nameVariant, harnessVariant], properties, sections… }
          // Shopify shares one `properties` object across every id here, so we
          // CANNOT just merge _eraya_* in — that would leak the harness's test
          // price onto the name-patch line. Convert to the standard items[] shape
          // so each line owns its properties and only the test line gets _eraya_*.
          if (Array.isArray(obj.id)) {
            var baseQty = obj.quantity != null ? obj.quantity : 1;
            var baseProps = (obj.properties && typeof obj.properties === 'object') ? obj.properties : {};
            var anyTest = false;
            var lines = obj.id.map(function (rawId) {
              var line = { id: rawId, quantity: baseQty, properties: Object.assign({}, baseProps) };
              if (rawId != null && typeof rawId !== 'object') {
                var pl = buildProps(rawId);
                if (pl) { Object.assign(line.properties, pl); anyTest = true; }
              }
              return line;
            });
            if (!anyTest) return body; // nothing under test → leave the original array intact
            var rebuilt = {};
            Object.keys(obj).forEach(function (k) {
              if (k !== 'id' && k !== 'quantity' && k !== 'properties') rebuilt[k] = obj[k];
            });
            rebuilt.items = lines; // preserves sections / sections_url etc.
            return JSON.stringify(rebuilt);
          }

          // Shapes A & B — standard { items: [ {id,…}, … ] } or { id: <scalar>, … }.
          var items = Array.isArray(obj.items)
            ? obj.items
            : (obj.id != null ? [obj] : null);
          if (!items) return body;
          var changed = false;
          items.forEach(function (it) {
            if (it && it.id != null && typeof it.id !== 'object') {
              var p = buildProps(it.id);
              if (p) { it.properties = Object.assign({}, it.properties || {}, p); changed = true; }
            }
          });
          return changed ? JSON.stringify(obj) : body;
        }
        // form-urlencoded string
        if (hasEraya(body)) return body;
        var params = new URLSearchParams(body);
        var idS = params.get('id'); if (!idS) return body;
        var pS = buildProps(idS); if (!pS) return body;
        Object.keys(pS).forEach(function (k) { params.set('properties[' + k + ']', String(pS[k])); });
        return params.toString();
      }
    } catch (_) {}
    return body;
  }

  // fetch — the primary add-to-cart transport (product-form.js, dfco-dring-gift,
  // main-product-scripts). Handles string url + init.body (the common shape).
  if (typeof window.fetch === 'function') {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (isCartAdd(url) && getManager() && init && init.body != null) {
          init = Object.assign({}, init);
          init.body = injectBody(init.body);
          return _fetch.call(this, input, init);
        }
      } catch (_) {}
      return _fetch.apply(this, arguments);
    };
  }

  // XMLHttpRequest — the user reported this path is where the SDK misses.
  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var XP = window.XMLHttpRequest.prototype;
    var _open = XP.open;
    var _send = XP.send;
    XP.open = function (method, url) {
      try { this.__erayaCartAdd = isCartAdd(url); } catch (_) { this.__erayaCartAdd = false; }
      return _open.apply(this, arguments);
    };
    XP.send = function (body) {
      try {
        if (this.__erayaCartAdd && getManager() && body != null) {
          return _send.call(this, injectBody(body));
        }
      } catch (_) {}
      return _send.apply(this, arguments);
    };
  }
})();
